import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";
import { AnimatePresence } from "framer-motion";

// style rules
import { Sizes } from "../../styles";

// Components
import CastMemberCard from "./CastMemberCard";
import CastMemberModal from "./CastMemberModal";

const App = ({ castMembersJson }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [selectedCastMember, setSelectedCastMember] = useState(null);
	const [castMembers] = useState(
		castMembersJson ? JSON.parse(castMembersJson) : []
	);

	// handles the scroll behavior on open and closing of the Modal
	useEffect(() => {
		if (isModalOpen) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "scroll";
		}
	}, [isModalOpen]);

	const toggleModal = (castMember) => {
		if (castMember) {
			setSelectedCastMember(castMember);
		} else {
			setSelectedCastMember(null);
		}
		return setIsModalOpen((currentState) => !currentState);
	};

	const renderCastCards = () => {
		return (
			castMembers &&
			castMembers.length > 0 &&
			castMembers.map((castMember) => {
				return (
					<CastMemberCard
						isPartOfGrid={castMembers.length > 2}
						key={castMember.id}
						castMember={castMember}
						toggleModal={toggleModal}
					/>
				);
			})
		);
	};

	return (
		<>
			<CastMembersWrapper isGrid={castMembers.length > 2}>
				{renderCastCards()}
			</CastMembersWrapper>
			<AnimatePresence>
				{isModalOpen && selectedCastMember && (
					<CastMemberModal
						toggleModal={toggleModal}
						castMember={selectedCastMember}
					/>
				)}
			</AnimatePresence>
		</>
	);
};

export default App;

const CastMembersWrapper = styled.ul`
	display: ${(props) => (props.isGrid ? "grid" : "flex")};
	${(props) => props.isGrid && "grid-template-columns: repeat(2, 1fr)"};
	${(props) => !props.isGrid && "flex-direction: column"};
	row-gap: 1.9rem;
	column-gap: 1.7rem;
	margin: 0 0 6rem;
	padding: 0;
	max-width: unset;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
	}
`;

App.propTypes = {
	castMembersJson: PropTypes.any,
};
